import styled, { css } from 'styled-components';
import { colors } from '../styles/theme';

const getHeaderGradient = () =>
  `linear-gradient(to bottom, ${colors.photoGradientStart}, ${colors.photoGradientEnd})`;

export const HeaderWrap = styled.section`
  display: grid;
  overflow: hidden;
  width: 100%;
`;

const sharedHeaderStyles = css`
  background-color: ${props => props.theme.colors.blueBackground};
  background-size: cover;
  background-position: center;
  height: 50vw;
`;

export const Header = styled.header.attrs(({ img }) => ({
  style: {
    backgroundImage: img ? `${getHeaderGradient()}, url(${img})` : null,
  },
}))`
  ${sharedHeaderStyles};
  display: grid;
  width: 100%;
  max-width: 1200px;
  max-height: 600px;
  margin: 0 auto;
  grid-area: 1 / 1;
`;

export const BlurredHeader = styled.div.attrs(({ img }) => ({
  style: {
    backgroundImage: img ? `${getHeaderGradient()}, url(${img})` : null,
  },
}))`
  ${sharedHeaderStyles};
  position: relative;
  max-height: 610px;
  filter: blur(20px);
  z-index: -1;
  margin: -10px;
  grid-area: 1 / 1;
  transform: scale(1.1);
  display: none;
  ${props => props.theme.media.giant`
    display: initial;
  `};
`;

export const HeaderBottomWrap = styled.div`
  display: flex;
  align-items: center;
  margin: auto 20px 20px 20px;

  h1 {
    color: #fff;
    margin: 0;
    font-size: 24px;
    font-weight: normal;
    ${props => props.theme.media.tablet`
      font-size: 36px;
    `};
    ${props => props.theme.media.giant`
      font-size: 45px;
    `};
  }
`;
